<template>
  <div id="loading-cells" class="vs-con-loading__container">
    <cell-sidebar :cellId="cellId" @reload="handleSearch" />
    <vs-card>
      <cell-table
        :data="cells"
        @add="handleAdd"
        @edit="handleEdit"
        @delete="handleDelete"
        @search="handleSearch"
      />
    </vs-card>
  </div>
</template>

<script>
import CellTable from './components/CellTable.vue'
import CellSidebar from './components/CellSidebar.vue'
import dashboard from '@/http/requests/dashboard'
export default {
  components: {
    CellTable,
    CellSidebar,
  },
  data() {
    return {
      cellId: null,
      cells: [],
      search: '',
      loading: false,
    }
  },
  methods: {
    getData() {
      this.loading = true
      dashboard
        .getCellList({ search: this.search })
        .then((res) => {
          this.cells = res.data.cells
          this.loading = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading = false
        })
    },
    handleAdd(e) {
      this.cellId = null
      this.$store.dispatch('toggleSidebar', 'sidebar-cell')
    },
    handleEdit(e) {
      console.log('edit', e)
      this.cellId = e
      this.$store.dispatch('toggleSidebar', 'sidebar-cell')
    },
    handleDelete(e) {
      this.cellId = e
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm_delete,
        text: this.$i18n.messages[this.$i18n.locale].delete_message_confirm,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteCell,
      })
    },
    handleSearch(e = '') {
      this.search = e
      this.getData()
    },
    deleteCell() {
      this.loading = true
      dashboard
        .deleteCell({cellId:this.cellId})
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'CELL',
            text: 'DELETED',
          })
          this.loading = false
          this.handleSearch(this.search)
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading = false
        })
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: '#loading-cells',
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-cells > .con-vs-loading`)
      }
    },
  },
}
</script>

<style>
</style>